import React from 'react';
import LoginForm from 'forms/LoginForm';

export default (): JSX.Element => <LoginForm />;
